// Minimal PKCE + Hosted UI helpers for Cognito

function base64UrlEncode(bytes) {
  return btoa(String.fromCharCode.apply(null, Array.from(bytes)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export async function generateCodeVerifierAndChallenge() {
  const array = new Uint8Array(32);
  (typeof window !== 'undefined' && window.crypto ? window.crypto.getRandomValues(array) : array).set(array);
  const verifier = base64UrlEncode(array);
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await (typeof window !== 'undefined' && window.crypto && window.crypto.subtle
    ? window.crypto.subtle.digest('SHA-256', data)
    : Promise.resolve(data));
  const challenge = base64UrlEncode(new Uint8Array(digest));
  return { verifier, challenge };
}

export function buildAuthUrl({ domain, clientId, redirectUri, scope = 'openid email profile', codeChallenge, prompt }) {
  // prompt=login forces Cognito to show the username/password screen even if a
  // previous SSO session exists. This is used after explicit app logout so a
  // user cannot immediately re‑enter via the Hosted UI "Continue" flow without
  // re‑authenticating.
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: clientId,
    redirect_uri: redirectUri,
    scope,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256'
  });
  if (prompt) {
    params.set('prompt', prompt);
  }
  return `${domain.replace(/\/$/, '')}/oauth2/authorize?${params.toString()}`;
}

export function buildLogoutUrl({ domain, clientId, logoutRedirectUri }) {
  const params = new URLSearchParams({
    client_id: clientId,
    logout_uri: logoutRedirectUri
  });
  return `${domain.replace(/\/$/, '')}/logout?${params.toString()}`;
}

